// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"ccf8ed63","422":"10bccd97"}[chunkId] + ".chunk.js";
};